var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pagination" },
    [
      _c("el-pagination", {
        attrs: {
          "current-page": _vm.pageNum,
          layout: "prev, pager, next",
          total: _vm.total,
        },
        on: {
          "size-change": _vm.sizeChange,
          "current-change": _vm.currentChange,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }